<!-- 最终展示-->
<template>
  <div class>
    <template v-if="item.isCompound === '1'">
      <el-form
        v-show="
          item.commonConf
            ? item.commonConf[0].comShow
              ? !item.commonConf[0].comShow
              : true
            : true
        "
        :label-width="item.busiCode[0].formConfig.labelWidth + 'px'"
        :label-position="item.busiCode[0].formConfig.labelPosition"
        :size="item.busiCode[0].formConfig.size"
        v-if="
          item.busiCode[0].formConfig != null &&
          item.busiCode[0].formConfig.formType == '2'
        "
        :model="formObj"
        :rules="item.busiCode[0].formConfig.rules"
        ref="formObj"
        :style="{
          position: 'relative',
          background: item.busiCode[0].formConfig.formDobgcl,
          'border-radius': item.busiCode[0].formConfig.formBTras + 'px',
          width: item.busiCode[0].formConfig.formWh,
          height: 'auto',
          margin: '0 auto',
        }"
        :id="item.code"
      >
        <div
          v-if="item.busiCode[0].formConfig.ifclosed"
          class="form-close"
          @click="hideFormPop"
        >
          <i class="el-icon-close"></i>
        </div>
        <h1
          v-if="item.busiCode[0].formConfig.iftit"
          :style="{
            color: item.busiCode[0].formConfig.titColor,
            'font-size': item.busiCode[0].formConfig.titSize + 'rem',
            'font-weight': item.busiCode[0].formConfig.titWeight,
          }"
          class="form-title"
        >
          {{ item.busiCode[0].formConfig.title }}
        </h1>

        <template v-for="(formBasic, index) in item.busiCode[0].content">
          <component
            :is="getComponents(formBasic.bannerType)"
            :item="formBasic"
            :key="index"
          ></component>
        </template>
        <div class="form-btn" @click="saveHandle(item, 'formObj')">
          <el-button
            v-if="item.busiCode[0].formConfig.idbtn"
            type="button"
            :style="{
              width: item.busiCode[0].formConfig.btnWh + 'rem',
              height: item.busiCode[0].formConfig.btnHei + 'rem',
              'font-size': item.busiCode[0].formConfig.bfontSize + 'rem',
              'font-weight': item.busiCode[0].formConfig.bfontWeight,
              color: item.busiCode[0].formConfig.bfontColor,
              'background-color': item.busiCode[0].formConfig.btnBgColor,
              'border-radius': item.busiCode[0].formConfig.btnBorderRas + 'px',
            }"
            >{{
              item.busiCode[0].formConfig.btnConfig &&
              item.busiCode[0].formConfig.btnConfig.btntxt
                ? item.busiCode[0].formConfig.btnConfig.btntxt
                : "确定"
            }}</el-button
          >
        </div>
      </el-form>
      <el-form
        v-show="
          item.commonConf
            ? item.commonConf[0].comShow
              ? !item.commonConf[0].comShow
              : true
            : true
        "
        :label-width="item.busiCode[0].formConfig.labelWidth + 'px'"
        :label-position="item.busiCode[0].formConfig.labelPosition"
        :size="item.busiCode[0].formConfig.size"
        v-if="
          item.busiCode[0].formConfig != null &&
          item.busiCode[0].formConfig.formType == '1'
        "
        :model="formObj"
        :rules="item.busiCode[0].formConfig.rules"
        ref="formObj"
        :style="{
          position: 'relative',
          background: item.busiCode[0].formConfig.formDobgcl,
          'border-radius': '0px',
          width: '100%',
          height: '100%',
          margin: '0 auto',
        }"
        :id="item.code"
      >
        <div
          v-if="item.busiCode[0].formConfig.ifclosed"
          class="form-close"
          @click="hideFormPop"
        >
          <i class="el-icon-close"></i>
        </div>
        <h1
          v-if="item.busiCode[0].formConfig.iftit"
          :style="{
            color: item.busiCode[0].formConfig.titColor,
            'font-size': item.busiCode[0].formConfig.titSize + 'rem',
            'font-weight': item.busiCode[0].formConfig.titWeight,
          }"
          class="form-title"
        >
          {{ item.busiCode[0].formConfig.title }}
        </h1>

        <template v-for="(formBasic, index) in item.busiCode[0].content">
          <component
            :is="getComponents(formBasic.bannerType)"
            :item="formBasic"
            :key="index"
          ></component>
        </template>
        <div class="form-btn" @click="saveHandle(item, 'formObj')">
          <el-button
            v-if="item.busiCode[0].formConfig.idbtn"
            type="button"
            :style="{
              width: item.busiCode[0].formConfig.btnWh + 'rem',
              height: item.busiCode[0].formConfig.btnHei + 'rem',
              'font-size': item.busiCode[0].formConfig.bfontSize + 'rem',
              'font-weight': item.busiCode[0].formConfig.bfontWeight,
              color: item.busiCode[0].formConfig.bfontColor,
              'background-color': item.busiCode[0].formConfig.btnBgColor,
              'border-radius': item.busiCode[0].formConfig.btnBorderRas + 'px',
            }"
            >{{
              item.busiCode[0].formConfig.btnConfig &&
              item.busiCode[0].formConfig.btnConfig.btntxt
                ? item.busiCode[0].formConfig.btnConfig.btntxt
                : "确定"
            }}</el-button
          >
        </div>
      </el-form>
    </template>
    <!-- 基础表单 -->
    <template v-else-if="item.isCompound === '3'">
      <el-form
        :key="index"
        :label-width="item.busiCode[0].labelWidth + 'px'"
        :label-position="item.busiCode[0].labelPosition"
        :size="item.busiCode[0].size"
      >
        <component
          :is="getComponents(item.bannerType)"
          :item="item"
          :formConfig="formConfig"
          :form="form"
          v-show="
            item.commonConf
              ? item.commonConf[0].comShow
                ? !item.commonConf[0].comShow
                : true
              : true
          "
        ></component>
      </el-form>
    </template>
    <template v-else-if="item.isCompound === '4'">
      <div
        :style="LineStyle"
        :class="
          item.ifdisplay == 1 ? 'layoutBox_box display' : 'layoutBox_box '
        "
      >
        <cus-widge :list="item.column" :formConfig="formConfig"></cus-widge>
      </div>
    </template>
    <!-- 基础组件 -->
    <template v-else>
      <component
        :is="getComponents(item.bannerType)"
        :item="item"
        :formConfig="formConfig"
        :form="form"
        v-show="
          item.commonConf
            ? item.commonConf[0].comShow
              ? !item.commonConf[0].comShow
              : true
            : true
        "
      ></component>
    </template>
  </div>
</template>

<script>
//这里可以导入其它文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》from ‘《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    CusWidge: () => import("./cusWidge.vue"),
  },
  props: ["formConfig", "item", "form"],
  data() {
    //这里存放数据
    return {
      // form: {},
    };
  },
  //计算属性 类似于data概念
  computed: {
    ifdisplay: function () {
      if (this.item.busiCode && this.item.busiCode[0].ifdisplay === true) {
        return (this.item.busiCode[0].ifdisplay = 1);
      } else if (
        this.item.busiCode &&
        this.item.busiCode[0].ifdisplay === false
      ) {
        return (this.item.busiCode[0].ifdisplay = 0);
      }
    },

    LineStyle() {
      if (this.item.hasOwnProperty("busiCode")) {
        return {
          "padding-left": this.item.busiCode[0].width + "rem",
          "padding-right": this.item.busiCode[0].paddingRight + "rem",
          "background-color": this.item.busiCode[0].backgroundColor,
          "background-image": this.item.busiCode[0].backgroundImage,
          "background-size":
            this.item.busiCode[0].bgwidth +
            "rem," +
            this.item.busiCode[0].bgHeight +
            "rem",
          opacity: this.item.busiCode[0].opacity,
          display: "flex",
          "justify-content": this.item.busiCode[0].justifyContent,
          "flex-direction": "row",
          "flex-wrap": "wrap",
        };
      }
      return {};
    },
  },
  //监控data中数据变化
  watch: {},
  //方法集合
  methods: {
    getComponents(type) {
      let result = ""; //默认是input类型
      if (type !== "type") {
        result = type;
      }
      return result;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期-创建之前
  beforeCreated() {},
  //生命周期-挂载之前
  beforeMount() {},
  //生命周期-更新之前
  beforUpdate() {},
  //生命周期-更新之后
  updated() {},
  //生命周期-销毁之前
  beforeDestory() {},
  //生命周期-销毁完成
  destoryed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.layoutBox_box {
  width: 100%;
  // background-color: #fff;
  min-height: 1rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.display {
  display: flex;
}
</style>